"use client"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { useState, useEffect } from "react"
import {
  ActionBlock,
  ActionBlockProps,
} from "@/components/terra/component/ActionBlock/ActionBlock"

const FormatActionBlock = ({
  actionBlockData,
  isEmbedded = false,
}: {
  actionBlockData: any
  isEmbedded?: boolean
}) => {
  const [blockBgColor, setBlockBgColor] = useState<string>("transparent")
  const formattedActionBlockTheme =
    actionBlockData?.theme === "Action Yellow"
      ? "t2-action-theme-one"
      : actionBlockData?.theme === "Action Black"
        ? "t2-action-theme-two"
        : actionBlockData?.theme === "Action White"
          ? "t2-action-theme-three"
          : "t2-action-theme-four"

  const formattedActionBlockForm = {
    ...actionBlockData?.form,
    description:
      actionBlockData?.form?.description?.json &&
      documentToReactComponents(actionBlockData.form.description.json),
    followUpMessage:
      actionBlockData?.form?.followUpMessage?.json &&
      documentToReactComponents(actionBlockData.form.followUpMessage.json),
  }

  const displayMode = actionBlockData?.displayType ? "email" : "buttons"
  let actionBlockButtons = actionBlockData?.buttonsCollection?.items?.map(
    (button: any) => {
      return {
        ...button,
        label: button?.textLabel || button?.label,
        destination: button?.url || button?.linkUrl,
        primary: button?.isPrimary,
        downloadName: button?.downloadName,
      }
    },
  )

  if (displayMode === "email") {
    actionBlockButtons = [{ label: actionBlockData?.formFieldPlaceholder }]
  }

  /* eslint-disable react-hooks/set-state-in-effect */
  useEffect(() => {
    if (typeof window !== "undefined") {
      const landingPageContainer = document.querySelector(
        ".landing-page-container",
      )
      // Landing pages tint the wrapper to blend with the last section's theme.
      // Article/case-study pages keep the default transparent background.
      if (landingPageContainer !== null) {
        const matchingElemClasses =
          landingPageContainer.lastElementChild?.querySelector(
            'div[class*="t2-theme-"]',
          )?.classList
        matchingElemClasses?.forEach(className => {
          if (className.startsWith("t2-theme-")) {
            setBlockBgColor(className)
          }
        })
      }
    }
  }, [setBlockBgColor])
  /* eslint-enable react-hooks/set-state-in-effect */

  // t2-action-block t2-action-block--sitewide w-full px-5 lg:px-20 m-auto max-w-[1440px]
  return (
    <div className={`t2-action-block-wrapper ${blockBgColor}`}>
      <div className="w-full px-5 lg:px-20 m-auto max-w-[1440px] relative">
        <div
          className={`m-0 mx-auto p-0 ${isEmbedded ? "" : "-mb-8 min-sm:-mb-16"}`}
        >
          <ActionBlock
            header={actionBlockData?.title}
            buttons={actionBlockButtons}
            headerIcon={actionBlockData?.headerIcon}
            presetTheme={
              formattedActionBlockTheme as ActionBlockProps["presetTheme"]
            }
            formPlaceholder={actionBlockData?.formFieldPlaceholder}
            formData={formattedActionBlockForm}
            displayType={displayMode}
          />
        </div>
      </div>
    </div>
  )
}

export default FormatActionBlock
